<template>
  <div :class="spanClass">
    <span>{{ params.dividend(params) }}</span> / {{ params.divisor() }}
  </div>
</template>

<script>
  export default {
    name: 'NumOutOfNumReadonlyCell',
    computed: {
      spanClass() {
        return this.params.dividend(this.params) != this.params.divisor() ? 'cell-over-limit' : '';
      },
    },
  }
</script>

<style scoped lang="scss">
  .cell-over-limit span {
    color: var(--v-resRed-darken1);
  }
</style>
